import { Navigate, Outlet } from 'react-router-dom';

import { usePortalConfigs } from 'hooks/usePortalConfigs';
import { useSelectedProfilePortalConfig } from 'hooks/useSelectedProfilePortalConfig';

// `perProfile` gates by the profile selected on Home (the same config the
// upsell cards use), so a card that is shown always leads to an open page.
// Without it the gate is account-wide: any activated kit hiding upsells
// closes the route, which is what deep links without a profile need.
const UpsellRoute = ({ perProfile = false }: { perProfile?: boolean }) => {
  const accountConfig = usePortalConfigs();
  const profileConfig = useSelectedProfilePortalConfig();
  const { config, isLoading } = perProfile ? profileConfig : accountConfig;

  if (isLoading) return null;
  if (config.hide_upsells) return <Navigate to='/' replace />;
  return <Outlet />;
};

export default UpsellRoute;
